"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ = _interopRequireDefault(require("@carbon/icons-react/lib/arrow--left/32.js"));
var _reactRouterDom = require("react-router-dom");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ".GoBackButton-container {\n  justify-content: center;\n  display: flex; }\n  .GoBackButton-container .article-back-button {\n    cursor: pointer; }\n";
  const fileName = "GoBackButton_GoBackButton";
  const element = document.querySelector("style[data-sass-component='GoBackButton_GoBackButton']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const GoBackButton = _ref => {
  let {
    history,
    lang
  } = _ref;
  const goBack = history?.location?.key;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "GoBackButton-container "
  }, goBack ? /*#__PURE__*/_react.default.createElement(_.default, {
    onClick: () => {
      history.goBack();
    },
    className: "article-back-button sia-margin-05-top sia-margin-05-bottom"
  }) : /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: '/' + lang
  }, /*#__PURE__*/_react.default.createElement(_.default, {
    className: "article-back-button sia-margin-05-top sia-margin-05-bottom"
  })));
};
var _default = exports.default = GoBackButton;